module.exports = __webpack_public_path__ + "static/img/physical_harm_1.31462549.png";